import React from 'react';
interface Tab {
  id: string;
  label: string;
}
interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
}
export function Tabs({
  tabs,
  activeTab,
  onChange
}: TabsProps) {
  return <div className="border-b border-slate-200 mb-6" data-id="element-160">
      <div className="flex gap-8" data-id="element-161">
        {tabs.map(tab => <button key={tab.id} onClick={() => onChange(tab.id)} className={`
              pb-4 text-sm font-medium transition-all relative
              ${activeTab === tab.id ? 'text-blue-600' : 'text-slate-500 hover:text-slate-800'}
            `} data-id="element-162">
            {tab.label}
            {activeTab === tab.id && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-t-full" data-id="element-163" />}
          </button>)}
      </div>
    </div>;
}